import g from "./_apply.js";
var p = g, o = Math.max;
function u(i, e, v) {
  return e = o(e === void 0 ? i.length - 1 : e, 0), function() {
    for (var n = arguments, r = -1, h = o(n.length - e, 0), l = Array(h); ++r < h; )
      l[r] = n[e + r];
    r = -1;
    for (var a = Array(e + 1); ++r < e; )
      a[r] = n[r];
    return a[e] = v(l), p(i, this, a);
  };
}
var d = u;
export {
  d as default
};
//# sourceMappingURL=_overRest.js.map
